module.exports = __webpack_public_path__ + "img/9788925535159.25e0a63c.jpg";